var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-earth") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layout/header/nav",
    transform: "translate(-1034.000000, -14.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1034.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-earth",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,13.2631579 C3.54642105,13.2631579 0.736842105,10.4535789 0.736842105,7 C0.736842105,6.58957895 0.779578947,6.188 0.854736842,5.79968421 C0.985157895,6.06421053 1.16863158,6.25136842 1.40368421,6.26463158 C2.08305263,6.30221053 2.57305263,6.22705263 2.64968421,6.68021053 C2.72410526,7.13263158 3.51694737,8.26515789 3.29073684,9.28421053 C3.06452632,10.3025263 3.74389474,10.9818947 4.49842105,11.2471579 C5.25294737,11.5102105 5.74442105,10.9074737 5.85715789,10.3025263 C5.97063158,9.69831579 6.30957895,9.058 6.61168421,9.09557895 C6.91452632,9.13315789 6.00821053,7.812 6.68757895,7.43473684 C7.36694737,7.05747368 8.23494737,6.24178947 8.19736842,5.86452632 C8.15831579,5.48726316 7.29178947,5.96252632 7.06484211,5.62284211 C6.83863158,5.28315789 5.38557895,3.72989474 6.00821053,3.39610526 C6.63157895,3.06231579 7.47968421,5.39663158 8.386,4.90736842 C9.29157895,4.41515789 9.48021053,4.18968421 9.06536842,3.96347368 C8.64905263,3.73578947 9.89505263,3.24505263 10.3482105,4.07547368 C10.8006316,4.90736842 10.9892632,5.66042105 11.48,6.00157895 C11.9707368,6.34052632 11.4048421,5.39663158 11.7062105,4.94347368 C12.0097895,4.49178947 12.3863158,3.69894737 12.5749474,4.75484211 C12.6670526,5.26842105 12.8733684,5.404 13.0273684,5.31778947 C13.1769474,5.85421053 13.2631579,6.41715789 13.2631579,7 C13.2631579,10.4535789 10.4535789,13.2631579 7,13.2631579 M7,0 C3.13378947,0 0,3.13452632 0,7 C0,10.8654737 3.13378947,14 7,14 C10.8662105,14 14,10.8654737 14,7 C14,3.13452632 10.8662105,0 7,0",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32450526,9.51277895 C6.79545263,9.73898947 7.05113684,10.5215158 7.36134737,10.6062526 C8.19250526,10.8339368 8.46366316,9.13551579 8.19250526,8.90856842 C7.92134737,8.68088421 7.85282105,9.28509474 7.32450526,9.51277895",
    id: "Fill-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEarth);
export default __webpack_public_path__ + "static/media/icon-earth.503b1dad97beb1e37c81dcf8a4d8e145.svg";
export { ForwardRef as ReactComponent };